import {
    AdditionalRatingStreamIQ,
    AdditionalRatingToya,
} from '@/types/vod/VodItemDetails'
import { Box } from '@mui/material'
import { hexToRgb } from '../lib'

const isAdditionalRatingToya = (
    additionalRating: AdditionalRatingToya | AdditionalRatingStreamIQ
): additionalRating is AdditionalRatingToya =>
    'symbols' in additionalRating &&
    'boxColor' in additionalRating &&
    'textColor' in additionalRating

const isAdditionalRatingStreamIQ = (
    additionalRating: AdditionalRatingToya | AdditionalRatingStreamIQ
): additionalRating is AdditionalRatingStreamIQ =>
    'rating' in additionalRating && 'system' in additionalRating

export const DisplayAgeRating = (
    additionalRating: AdditionalRatingToya | AdditionalRatingStreamIQ
): JSX.Element | JSX.Element[] => {
    if (isAdditionalRatingToya(additionalRating)) {
        const { symbols, boxColor, textColor } = additionalRating
        const style = {
            color: hexToRgb(textColor),
            backgroundColor: hexToRgb(boxColor),
            width: '30px',
            height: '30px',
            borderRadius: '3px',
            marginBottom: '13px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            typography: 'text1',
        }
        return symbols.map((symbol: string, index: number) => (
            <Box
                role="listitem"
                className="add-rating-container"
                key={index}
                style={style}>
                {symbol}
            </Box>
        ))
    } else if (isAdditionalRatingStreamIQ(additionalRating)) {
        const { rating, system } = additionalRating
        return (
            <Box
                role="listitem"
                className="add-rating-streamiq"
                style={
                    {
                        // Add styles
                    }
                }>
                {rating} {system}
            </Box>
        )
    }

    return <></>
}
